// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.physics.body

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.*
import io.github.erkko68.kolt.physics.collision.broadphase.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * Class function to filter out bodies, returns true if test should collide with body
 *
 * C++ `JPH::BodyFilter`.
 */
open class BodyFilter internal constructor(internal val bodyFilterHandle: NativePointer, owned: Boolean = false) : NativeObject(owned), AutoCloseable {
    /** Creates one whose functions a subclass overrides. */
    constructor() : this(JphBodyFilter_createUpcalls(Upcalls.function), owned = true) {
        if (this::class != BodyFilter::class) JphBodyFilter_bindUpcalls(bodyFilterHandle, Upcalls.reference(this))
    }

    override fun close() =
        closeOnce { JphBodyFilter_destroy(bodyFilterHandle) }

    /** Filter function. Returns true if we should collide with inBodyID */
    open fun shouldCollide(bodyID: BodyID): Boolean =
        JphBodyFilter_ShouldCollide(bodyFilterHandle, bodyID.value)

    /** Filter function. Returns true if we should collide with inBody (this is called after the body is locked and makes it possible to filter based on body members) */
    open fun shouldCollideLocked(body: Body): Boolean =
        JphBodyFilter_ShouldCollideLocked(bodyFilterHandle, body.bodyHandle)

    override fun nativeUpcall(method: Int, args: NativePointer, result: NativePointer): Boolean {
        when (method) {
            0 -> writeSlot(result, if (shouldCollide(BodyID(readSlot(args, 0).toInt()))) 1L else 0L)
            1 -> writeSlot(result, if (shouldCollideLocked(Body(readPointerSlot(args, 0)))) 1L else 0L)
            else -> return false
        }
        return true
    }
}
